/* jshint esversion: 6 */
import React from 'react';
import ErrorModule from 'app/mixins/ErrorModule.jsx';
import FieldError from 'app/components/common/FieldError.jsx';
import ConstantMixin from 'app/mixins/ConstantMixin.js';
import StyledSelect from 'app/components/common/StyledSelect.jsx';
import HelpButton from 'app/components/common/HelpButton.jsx';
import ToggleControl from 'app/components/common/ToggleControl.jsx';
import ShortenerProvider from 'app/redux/Providers/ShortenerProvider.jsx';
import DomainProvider from 'app/redux/Providers/DomainProvider.jsx';
import ComponentWithContext from 'app/components/Routers/ComponentWithContext.jsx';
import { compose } from 'redux';

class RouteShortenersPanel extends React.Component {
    constructor(props) {
        super(props);

        this.props.getDomains();
        this.props.getShorteners();

        this.updateField = this.updateField.bind(this);

    }

    updateField(e) {

        let value = e.currentTarget.value,
            info = value.split("-"),
            id = 0,
            fieldEvent = {
                currentTarget: {
                    dataset: {
                        field: ''
                    }
                },
                target: {
                    value: 0
                }
            },
            resetEvent = {
                currentTarget: {
                    dataset: {
                        field: ''
                    }
                },
                target: {
                    value: 0
                }
            };

        if (value === 'sysdef') {
            let shortenerFaker = {
                    currentTarget: {
                        dataset: {
                            field: 'route.saID'
                        }
                    },
                    target: {
                        value: null
                    }
                },
                domainFaker = {
                    currentTarget: {
                        dataset: {
                            field: 'route.pdID'
                        }
                    },
                    target: {
                        value: null
                    }
                };

            this.props.changeHandler(shortenerFaker);
            this.props.changeHandler(domainFaker);

        } else {
            if (info[0] === 'shortener') {
                fieldEvent.currentTarget.dataset.field = "route.saID";
                resetEvent.currentTarget.dataset.field = "route.pdID";
            } else if (info[0] === 'domain') {
                fieldEvent.currentTarget.dataset.field = "route.pdID";
                resetEvent.currentTarget.dataset.field = "route.saID";
            }

            fieldEvent.target.value = parseInt(info[1]);
            resetEvent.target.value = 0;

            this.props.changeHandler(resetEvent);
            this.props.changeHandler(fieldEvent);

        }

    }

    render() {
        let currentPanel = null,
            shortenerOptions = [
                {value: 'sysdef', label: 'Use system default (%default%)'},
                {value: 'shortener-0', label: 'dlvr.it'},
                {value: 'domain-1', label: 'Don\'t shorten links'}
            ],
            domainOptions = [], // no domain option is returned by API call so no need to create it here
            selectedShortener = this.props.route.saID !== null ? 'shortener-' + this.props.route.saID : 0,
            selectedDomain = this.props.route.pdID !== null && this.props.route.pdID >= 1 ? 'domain-' + this.props.route.pdID : 0,
            i = 0,
            selectedOption = 0,
            name = '',
            toggleActive = false,
            controlState = '',
            stateClass = '';

        // fill out the label template depending on the current system default
        if (this.props.user.detail.defaultSaId === 0 && this.props.user.detail.defaultPdId === 0) {
            shortenerOptions[0].label = shortenerOptions[0].label.replace("%default%", "dlvr.it");
        } else if (this.props.user.detail.defaultSaId === 0 && this.props.user.detail.defaultPdId === 1) {
            shortenerOptions[0].label = shortenerOptions[0].label.replace("%default%", "No Shortener");
        } else {
            if (this.props.user.detail.defaultSaId > 0) {
                let defaultShortener = this.props.shorteners.find(({id}) => { return id === this.props.user.detail.defaultSaId; });
                if (defaultShortener) {
                    shortenerOptions[0].label = shortenerOptions[0].label.replace("%default%", defaultShortener.name);
                }
            } else if (this.props.user.detail.defaultPdId > 1) {
                let defaultDomain = this.props.domains.find(({id}) => { return id === this.props.user.detail.defaultPdId; });
                if (defaultDomain) {
                    shortenerOptions[0].label = shortenerOptions[0].label.replace("%default%", defaultDomain.domain);
                }
            } else {
                shortenerOptions[0].label = shortenerOptions[0].label.replace("%default%", "");
            }
        }

        if (selectedDomain) {
            selectedOption = selectedDomain;
        } else if (selectedShortener) {
            selectedOption = selectedShortener;
        } else {
            selectedOption = 'sysdef';
        }

        if (this.props.shorteners.length) {
            for (i = 0; i < this.props.shorteners.length; ++i) {
                name = this.props.shorteners[i].name;
                if (parseInt(this.props.shorteners[i].ssID, 10) > 1) {
                    name = ConstantMixin.getShortenServiceByCode(this.props.shorteners[i].ssID) + " - " + name;
                }
                shortenerOptions.push({
                    value: 'shortener-' + this.props.shorteners[i].id,
                    label: name
                });
            }
        }

        if (this.props.domains.length) {
            for (i = 0; i < this.props.domains.length; ++i) {
                shortenerOptions.push({
                    value: 'domain-' + this.props.domains[i].id,
                    label: this.props.domains[i].domain
                });
            }
        }

        return (
            <div className="editor-panel">
                <fieldset>
                    <legend>
                        Link Shortening Service or Custom Domain<HelpButton which="routeShortenerOverride"/>
                    </legend>
                    <ErrorModule
                        app={this.props.app}
                        keys={['ROUTE_CREATE', 'ROUTE_UPDATE']}
                        render={(state) => {
                            return (
                                <FieldError field="saID" errors={state.errors}/>
                            );
                        }}/>
                    <ErrorModule
                        app={this.props.app}
                        keys={['ROUTE_CREATE', 'ROUTE_UPDATE']}
                        render={(state) => {
                            return (
                                <FieldError field="paID" errors={state.errors}/>
                            );
                        }}/>
                    <StyledSelect
                        options={shortenerOptions}
                        value={selectedOption}
                        onChange={this.updateField}
                        selectClass={"large " + stateClass}
                        controlState={controlState} />
                </fieldset>
            </div>
        );
    }

};

RouteShortenersPanel.displayName = "RouteShortenersPanel";

const enhance = compose(
    ComponentWithContext,
    DomainProvider,
    ShortenerProvider
);

export default enhance(RouteShortenersPanel);
